"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollLockController = void 0;
// 여러 호스트가 동시에 잠글 수 있으므로 전역 카운트로 관리한다.
// 마지막 호스트가 해제될 때만 body 스타일을 원복한다.
let scrollLockCount = 0;
let lockedScrollY = 0;
let previousBodyStyles = {};
function lockBodyScroll() {
    scrollLockCount += 1;
    if (scrollLockCount > 1)
        return;
    lockedScrollY = window.scrollY;
    previousBodyStyles = {
        left: document.body.style.left,
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        right: document.body.style.right,
        top: document.body.style.top,
        width: document.body.style.width,
    };
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
}
function unlockBodyScroll() {
    if (!scrollLockCount)
        return;
    scrollLockCount -= 1;
    if (scrollLockCount > 0)
        return;
    document.body.style.position = previousBodyStyles.position ?? '';
    document.body.style.top = previousBodyStyles.top ?? '';
    document.body.style.left = previousBodyStyles.left ?? '';
    document.body.style.right = previousBodyStyles.right ?? '';
    document.body.style.width = previousBodyStyles.width ?? '';
    document.body.style.overflow = previousBodyStyles.overflow ?? '';
    window.scrollTo(0, lockedScrollY);
    lockedScrollY = 0;
    previousBodyStyles = {};
}
/**
 * 활성 동안 body 스크롤을 잠그는 ReactiveController.
 *
 * 호스트당 한 번만 잠금을 점유하고, host가 disconnect되면 대칭으로 해제하므로
 * 컴포넌트마다 잠금 플래그와 정리 코드를 반복하지 않는다.
 * 전역 카운트를 공유하므로 모달이 중첩되어도 마지막 해제 시에만 원복된다.
 */
class ScrollLockController {
    constructor(host) {
        this.locked = false;
        host.addController(this);
    }
    hostDisconnected() {
        this.set(false);
    }
    /** active이면 잠그고 아니면 해제한다. 같은 상태로의 중복 호출은 무시된다. */
    set(active) {
        if (active === this.locked)
            return;
        this.locked = active;
        if (active)
            lockBodyScroll();
        else
            unlockBodyScroll();
    }
}
exports.ScrollLockController = ScrollLockController;
//# sourceMappingURL=data:application/json;base64,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